export default __webpack_public_path__ + "static/braid-48b17cda73dae47d47177321a2b1c175.png";